<div class="widget__wrap">
  <div class="widget" id="contentboxes-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Obsahové boxy</span
      >
      <span class="widget__header__tools">
        <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
        <a
          [routerLink]="['contentboxes/add']"
          class="cta cta--small cta--green"
        >
          <span class="cta__light">Přidat</span> box <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content">
      <swb-contentboxes-list [query]="query"></swb-contentboxes-list>
    </div>
  </div>
</div>
